module.exports = __webpack_public_path__ + "img/Tiere_1.d5d36a90.jpeg";